module.exports = __webpack_public_path__ + "img/experiences_E Play ball.b66c1025.jpg";